import { commonActionCreator } from '@confluence-classic/confluence-legacy-redux';

export const OPEN_PREVIEWER = 'OPEN_PREVIEWER';
export const openPreviewer = commonActionCreator(OPEN_PREVIEWER);

export const CLOSE_PREVIEWER = 'CLOSE_PREVIEWER';
export const closePreviewer = commonActionCreator(CLOSE_PREVIEWER);
